<template>
    <div class="goodsList-div" >
      <div class="index-wrapper" >
        <mall-header ></mall-header>
        <!-- <div class="goodsList-content" >
            <img src="../../static/images/BNNER.png" class="goodsList-bnner"  />
        </div> -->
        <div class="goodsList-content" style="background-image: url('../../static/images/BNNER.png');background-position: center;" >
        </div>
        <div class="accessory-result-page accessory-page">
          <div class="container" ref="accHock" v-loading.fullscreen.lock="fullscreenLoading">
            <div v-for="(value,key) in goodsMap">
                 <div style="margin-top: 25px;" >
                    <span class="DZ-class">{{key}}</span>
                 </div>
                    <div id="pro_form" class="goodsList-all-div"   >
                        <div  >
                            <el-row  >
                                <el-col  :span="4"  :style="index%4==0?'margin-left: 0px !important;':''" v-for="(datas, index) in value" :key="index"   :offset="index">
                                   <el-card :body-style="{ padding: '0px', height:'422px'}" class="el-card-css"  shadow="hover" >
                                        <div >
                                            <div @click="openGoodList(datas)">
                                                 <a ><img  class="span-img-css"  :src="datas.imgUrl" alt=""></a>
                                                <br/>
                                                <el-tooltip placement="right" :popper-append-to-body="false"    :disabled="showTooltip" :content='datas.name' >
                                                    <div @mouseenter="showTips($event)"  class="span-font-titel">{{datas.name}}</div>
                                                </el-tooltip>
                                                <br/>
                                                 <el-tooltip placement="right" :popper-append-to-body="false"  :disabled="isShowTooltip" :content='datas.description' >
                                                    <div @mouseenter="descriptionTips($event)"  class="span-font-css">{{datas.description}}</div>
                                                </el-tooltip>
                                                <span class="span-money-css">￥{{datas.unitPrice}}</span>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </div>
                         <el-backtop   style="right: initial;bottom: 40px;">
                            <div class="el-backtop-div">
                              <img src="../../static/images/backtop.png" style="margin-top: 15px;" />
                            </div>
                        </el-backtop>
                    </div>
              </div>
          </div>
        </div>

      </div>
      <div style="left: 0px;bottom: 0px;width: 100%;z-index:1;text-align: center; padding: 20px 0;    color: #999999;font-size: 14px;">
      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved
    </div>
    </div>
</template>
<script>
import "../assets/css/base.css"
import "../assets/css/login.css"
import "../assets/css/product.css"
import "../assets/css/checkout.css"
import "../assets/css/icomoon/style.css"
import "../assets/css/goods.css"

import mallHeader from '../components/header.vue'
import http from '../api/public'
import rquestCall from '../api/index'
import {
  productHome,
} from '../api/index'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
// import BScroll from 'better-scroll'
import axios from 'axios'
    export default{
      data() {
          return {
            goodsMap : {},
           goodsList:[],
           fullscreenLoading: true,
           currentDate: new Date(),
           showTooltip:false,
           isShowTooltip: false,
            slides: [],
           el: '.wraper',
          }
      },
      created() {
      },
      mounted() {
        this.getGoodList();

      },
      methods: {
        openGoodList(da){
            //this.$router.push({path: '/goodsDetails', query: {"id": da.id}})
            window.open("#/goodsDetails?id="+da.id);
        },
        //首页商品信息接口
        getGoodList(flag) {
          var url = "/mallApi/mall/index/list";
         http.getGoodsList(url).then( (res) => {
            if(res.status === 200) {
              this.goodsList =res.data.result.records;
                this.goodsList.forEach(da => {
                  da.imgUrl = "/mallApi"+da.imgUrl
                  da.unitPrice = http.changeUnitPrice(da.unitPrice);
                });
                this.groupGoodsList(this.goodsList);
            } else {
              this.$message.error(res.message);
            }
            this.fullscreenLoading= false;
  		  })

        },
        showTips(obj){
          let cWidth = obj.target.offsetWidth;
          let  sWidth = obj.currentTarget.scrollWidth;
          /*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
          sWidth > cWidth? this.showTooltip = false : this.showTooltip = true

        },
        descriptionTips(obj){
          let offHeight = obj.target.offsetHeight;
          let  sHeight = obj.currentTarget.scrollHeight;
          /*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
          sHeight > offHeight? this.isShowTooltip = false : this.isShowTooltip = true
        },
        //通过服务项目分类分组数据
        groupGoodsList(goodsList){
          let groupGoodMap = {};
          goodsList.forEach(item => {
            let groupGoodList = groupGoodMap[item.serviceClassName];
            if(groupGoodList == null ){
              let newDataList = [];
              newDataList.push(item);
              groupGoodMap[item.serviceClassName] = newDataList;
            }else{
              groupGoodList.push(item);
            }
          });
          this.goodsMap = groupGoodMap;
        }
      },
      components: {
        mallHeader,
        mallFooter,
        mallBread,
        http
      }
    }
</script>
<style >
#app {
 height: 100%;
 width: 100%;
}
.content {
   height: 100%;
}
.container {
    min-width: 1200px !important;
    width: 1200px;
    margin: 0px auto;
}



</style>



// WEBPACK FOOTER //
// GoodsList.vue?2ffaed6d